<template>
  <div style="white-space: pre-line">
    {{ creativeTypesText }}
  </div>
</template>

<script>
import { CreativeTypes } from '@/models/Creative'

const creativeTypeItems = [
  { value: CreativeTypes.BANNER, text: 'バナー（静止画）' },
  { value: CreativeTypes.INFEED, text: 'インフィード' },
  { value: CreativeTypes.VIDEO, text: '動画' },
]

export default {
  name: 'AppCreativeTypes',
  props: {
    creativeTypes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    creativeTypesText() {
      return this.creativeTypes
        .map(
          creativeType =>
            creativeTypeItems.find(type => type.value === creativeType).text,
        )
        .join('\n')
    },
  },
}
</script>
